import { loadMarketplaceCataloguePage } from "./Firestore/MarketplaceCatalogue.js";

// Load one bounded catalogue page for browsing. Return its cursor so an
// explicitly requested spreadsheet can fetch the remaining selected products.
export default async function LoadMarketplaceItems({
  farm,
  loadLimit,
  lastFarm,
  setFoodItems,
  setDisplayedFoodItems,
  setLoading,
  userInfo,
  pickupLocationDetails,
}) {
  try {
    const page = await loadMarketplaceCataloguePage({
      farm,
      loadLimit,
      userInfo,
      pickupLocationDetails,
    });
    setFoodItems((items) => [...items, ...page.items]);
    if (setDisplayedFoodItems) {
      setDisplayedFoodItems([]);
    }
    if (lastFarm) {
      setLoading(true);
    }
    return page;
  } catch (error) {
    console.error("Error loading marketplace products:", error);
    setLoading(true);
    return { farm, error };
  }
}
